module.exports = __webpack_public_path__ + "static/img/bg.fc3e4629.jpg";